import React from 'react';
import { Heatmap } from './Heatmap';

const data = [
  {
    count: 400,
    isCountry: false,
    location: {
      lat: 48.99999229,
      long: 8.399993448,
    },
  },
  {
    count: 40,
    isCountry: false,
    location: {
      lat: 50.26660748,
      long: 10.96660681,
    },
  },
  {
    count: 1200,
    isCountry: false,
    location: {
      // Berlin
      lat: 52.52181866,
      long: 13.40154862,
    },
  },
  {
    count: 200,
    isCountry: false,
    location: {
      // Berlin
      lat: 52.53,
      long: 13.41,
    },
  },
  {
    count: 700,
    isCountry: false,
    location: {
      lat: 51.7704175,
      long: 14.32996741,
    },
  },
  {
    count: 750,
    isCountry: false,
    location: {
      lat: 53.55002464,
      long: 9.999999144,
    },
  },
  {
    count: 75,
    isCountry: false,
    location: {
      lat: 51.30000694,
      long: 9.500029662,
    },
  },
  {
    count: 90,
    isCountry: false,
    location: {
      lat: 53.63330408,
      long: 11.41669861,
    },
  },
  {
    count: 170,
    isCountry: false,
    location: {
      lat: 53.1299986,
      long: 8.220004434,
    },
  },
  {
    count: 790,
    isCountry: false,
    location: {
      lat: 52.02998822,
      long: 8.530011351,
    },
  },
  {
    count: 1800,
    isCountry: false,
    location: {
      lat: 49.98247246,
      long: 8.273219156,
    },
  },
  {
    count: 1600,
    isCountry: false,
    location: {
      lat: 49.25039044,
      long: 6.970003213,
    },
  },
  {
    count: 99,
    isCountry: false,
    location: {
      lat: 50.82998395,
      long: 12.91997595,
    },
  },
  {
    count: 430,
    isCountry: false,
    location: {
      lat: 52.13042137,
      long: 11.62000362,
    },
  },
  {
    count: 610,
    isCountry: false,
    location: {
      lat: 54.78374778,
      long: 9.433315388,
    },
  },
  {
    count: 20,
    isCountry: false,
    location: {
      lat: 50.97005292,
      long: 11.02996212,
    },
  },
  {
    // another right next to it, so we can see the cluster
    count: 1,
    isCountry: false,
    location: {
      lat: 50.98,
      long: 11.04,
    },
  },
  {
    count: 420,
    isCountry: true,
    location: {
      long: 5.291266,
      lat: 52.132633,
    },
  },
].map((item, index) => ({
  ...item,
  id: String(index + 1),
}));

export function HeatmapExample(): JSX.Element {
  return <Heatmap data={data} />;
}
